import { PageProps } from 'core/page/page.props';

export const PagePresets: PageProps = {
  footerVisible: true,
};
